/**
 * 车标 PNG（lv/red/hui）箭头尖角默认朝向（像素实测 ≈67°，0=北、顺时针）。
 * CSS 旋转角 = 接口航向 − 此值；勿直接套用 PathSimplifier 的 initRotateDegree:-90
 *（那是「路径角 0=东」与「图标朝北」两套坐标系的桥接，不是素材尖角）。
 */
export const BICYCLE_MARKER_ICON_TIP_DEG = 67

/** @deprecated 使用 BICYCLE_MARKER_ICON_TIP_DEG；保留兼容旧名 */
export const BICYCLE_MARKER_INIT_ROTATE_DEG = -BICYCLE_MARKER_ICON_TIP_DEG

function parseHeadingNumber(value) {
  if (value == null || value === '') return NaN
  const n = Number(String(value).replace(/[^\d.-]/g, ''))
  if (!Number.isFinite(n)) return NaN
  return n
}

/** 航向角归一化到 [0, 360) */
export function normalizeHeadingDegrees(a) {
  if (a == null || !Number.isFinite(Number(a))) return null
  let deg = Number(a)
  if (deg < 0) deg += 360
  if (deg > 360) deg -= 360
  return deg
}

/**
 * 解析车辆航向角（度，0=北、顺时针）。
 * 优先接口 drc（含 0=正北），其次 head、agl。
 */
export function resolveHeadingDegrees(item) {
  if (!item || typeof item !== 'object') return null
  const raw = item.raw && typeof item.raw === 'object' ? item.raw : {}
  const drc = parseHeadingNumber(raw.drc != null ? raw.drc : item.drc)
  const head = parseHeadingNumber(raw.head != null ? raw.head : item.head)
  const agl = parseHeadingNumber(raw.agl != null ? raw.agl : item.agl)

  if (Number.isFinite(drc)) return normalizeHeadingDegrees(drc)
  if (Number.isFinite(head)) return normalizeHeadingDegrees(head)
  if (Number.isFinite(agl)) return normalizeHeadingDegrees(agl)
  return null
}

/**
 * 航向角 → 八方位（业务标准 getDirectionDesc）
 * @param {number} a 0~360 顺时针，0=北
 * @returns {string}
 */
export function getDirectionDesc(a) {
  if (a == null || !Number.isFinite(Number(a))) return ''
  let deg = Number(a)
  if (deg < 0) deg += 360
  if (deg > 360) deg -= 360

  if (deg <= 22.5 || deg > 337.5) return '北'
  if (deg > 22.5 && deg <= 67.5) return '东北'
  if (deg > 67.5 && deg <= 112.5) return '东'
  if (deg > 112.5 && deg <= 157.5) return '东南'
  if (deg > 157.5 && deg <= 202.5) return '南'
  if (deg > 202.5 && deg <= 247.5) return '西南'
  if (deg > 247.5 && deg <= 292.5) return '西'
  if (deg > 292.5 && deg <= 337.5) return '西北'
  return ''
}

/** @deprecated 使用 getDirectionDesc */
export function headingToDirectionText(headingDeg) {
  const text = getDirectionDesc(headingDeg)
  return text || '—'
}

/** 方向文案（表格/信息窗/地图车标共用：先 resolveHeadingDegrees 再 getDirectionDesc） */
export function formatDirectionText(item) {
  const deg = resolveHeadingDegrees(item)
  if (deg != null) {
    const text = getDirectionDesc(deg)
    return text || '—'
  }
  return item && item.agl != null && item.agl !== '' ? String(item.agl) : '—'
}

/** 车标箭头 CSS rotate：航向角 − 素材默认尖角 */
export function markerIconRotateDeg(headingDeg) {
  const a = normalizeHeadingDegrees(headingDeg)
  if (a == null) return -BICYCLE_MARKER_ICON_TIP_DEG
  return a - BICYCLE_MARKER_ICON_TIP_DEG
}

/** @deprecated 使用 markerIconRotateDeg */
export function markerAmapAngleDeg(headingDeg) {
  return markerIconRotateDeg(headingDeg)
}

/** @deprecated 使用 markerIconRotateDeg */
export function markerCssRotateDeg(headingDeg) {
  return markerIconRotateDeg(headingDeg)
}
